import axios from "axios";
import Cookies from "js-cookie";
import { apiV1BaseUrl } from "./index";

const accessToken = () => Cookies.get("accessToken");
export const postFinancialTimeseriesByFeature = async ({
  minPayout,
  maxPayout,
  deductible,
  sumInsured,
  triggerLevel,
  exitLevel,
  country,
  adminLevel,
  locationIds,
  seasons,
  comparisonFocus,
  type,
  download,
}: {
  minPayout: string;
  maxPayout: string;
  deductible: string;
  sumInsured: string;
  triggerLevel: number;
  exitLevel: number;
  country: string;
  adminLevel: string;
  locationIds: string[];
  comparisonFocus: number;
  download?: boolean;
  seasons: {
    season: number;
    percent: number;
    indicators: {
      indicatorId: string;
      startMonth: number;
      endMonth: number;
      startDekad: number;
      endDekad: number;
      hybridIndicators?: { indicator: string; weight: number }[];
    }[];
  }[];
  type: string;
}) => {
  try {
    const urlToFetch = `${apiV1BaseUrl}/timeseries/Payout`;

    const response = await axios.post(
      urlToFetch,
      {
        type:
          type === "user" && adminLevel !== "1" && adminLevel !== "2"
            ? "user"
            : "system",
        minPayout,
        maxPayout,
        deductible,
        sumInsured,
        triggerLevel,
        exitLevel,
        country,
        adminLevel,
        comparisonFocus: comparisonFocus === 0 ? 2 : comparisonFocus,
        locationIds,
        seasons,
      },
      {
        responseType: download ? "blob" : "json",
        headers: {
          ...(accessToken()
            ? { Authorization: `Bearer ${accessToken()}` }
            : {}),
        },
        params: {
          ...(download ? { download } : {}),
        },
      },
    );

    if (download) {
      const blob = new Blob([response.data], {
        type: "application/zip",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      // Try to read filename from backend
      const disposition = response.headers["content-disposition"];
      const filename =
        disposition?.match(/filename="?(.+?)"?$/)?.[1] ??
        "financial-timeseries.zip";

      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
      return;
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};
